import React, {useState,useEffect}from "react";
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";

import './CRMlogin.css'
import "../Dashboard/Profile/Profile.css";

import { useRouteMatch,Switch, Route } from "react-router-dom";
import { loginLeadManager } from "../../store/actions/CRM/loginLeadManager";

import { useHistory } from "react-router-dom/cjs/react-router-dom";

import {  Link  } from "react-router-dom";
import { checkLeadManagerLoginStatus } from "../../store/actions/CRM/checkLeadManagerLoginStatus";
 const CRMLogin = ({baseUrl})=>{
    // const {category} = useParams();
   const {url,path} =useRouteMatch();
    
     const history = useHistory();
    
   const dispatch = useDispatch();
 
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
  
   const [loader , setLoader] =useState({status:false});
   const [login, setLogin] = useState({user_email:'',user_pass:"",currentToken:""
   
  });

  const [open , setOpen]=useState(false);

     const [statusData , setStatusData] =useState(false);
   const currentToken = useSelector((state)=>state?.user?.user?.token);
     const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
   
       
       
     const CRMtoken= useSelector((state)=>state?.crmData?.crmPass);
     
     const userdata = useSelector((state)=>state?.user?.user);
   
 useEffect(() => {
     setOpen(false) 
  setLoader({status:true});
  const LeadManagerLoginStatusData= {userEmail:userdata?.user_email,CRMtoken:CRMtoken,currentToken:currentToken}
     const user = dispatch(checkLeadManagerLoginStatus(LeadManagerLoginStatusData));
     /* get response as Promise   */
     user.then(response => {
     // pop up with message 
     //   console.log(response)
     setStatusData(response)
 
     if(response?.crmAccessStatus=='yes'){history.push(`${baseUrl}/dashboard`);}else{ history.push(`${baseUrl}/crm-login`);}
    
      setInterval(()=>{
       // hide poped message 
       
      },3000)
      
  
   
   setLoader({status:false});
   
   
   
     }).catch(error => {
       
   /* resetting Login input Fields */
   //setLogin({user_email:'',user_pass:""
   
   // })
   setLoader({status:false});
       console.error(error);
     });
    
 
 
 
   }, []);
  



  /* Handle Signup Function */
const handleLogin=(e)=>{

    e.preventDefault();
  //console.log(signup)
  
  setLoader({status:true});
    const user = dispatch(loginLeadManager(login));
    /* get response as Promise   */
    user.then(response => {
    // pop up with message 
    //  console.log(response)
     
history.push(`${baseUrl}/dashboard`);
//      setInterval(()=>{
//       // hide poped message 
      
// history.push(baseUrl);
//      },3000)
     
  /* resetting Login input Fields */
  
  setLogin({user_email:'',user_pass:""
  
  })
  
  setLoader({status:false});
  
  
  
    }).catch(error => {
      
  /* resetting Login input Fields */
  //setLogin({user_email:'',user_pass:""
  
  // })
  setLoader({status:false});
      console.error(error);
    });
   
    }



  
       return <>
 
{statusData?
 <div className={` bgGradient1` } style={{zIndex:"99"}} >
  <div></div>
<div className = {`  `}style={{zIndex:"99"}}   id="outer-left">

    
    </div>
    <div className="outer-right">
       

    
<div className="outer-profile content-top">
<div className="outer-profile-in  ">
<div className="outer-profile-title ">CRM Login

</div><div className="outer-profile-subvals outer-profile-title ">
    {"Hey "+(userdata?.first_name?userdata?.first_name:" There! ")+" Welcome to  classmock.com" }</div>
    <div className=""></div>





    <div  className="CreateCourseStepsOuterLeftTwo"style={{
      
      }}>
  
  
    <div style={{padding:"10px"}}className="create-card-title">
   Login To CRM</div><br/>
<div class="CreateCourseStepsOuterTitle"> To Get Started - Login To CRM </div>
<div class="CreateCourseStepsOuterSubTitle"> </div>
</div>
   


        
</div>
<div  className=" profile-outer-right" >

   

        <div className="">
        <form onSubmit={handleLogin} >
  
  <h1 style={{textAlign:"center",color:"#222"}}> CRM Login </h1>
  
<div  className="ikcraft_login-input-card">
<input className="ikcraft_input-textbox" required placeholder="Email" type="text"
name="user_email" value={login.user_email} onChange={(e)=>setLogin({...login, user_email : e.target.value})} />

 <input className="ikcraft_input-textbox" required placeholder="Password" 
 type="text" name="user_pass" value={login.user_pass}
  onChange={(e)=>setLogin({...login, user_pass : e.target.value,currentToken:currentToken})} />
</div>
  




 


<div  className="ikcraft_login-input-card">

<button   className="crm-button-one" type="submit" id="signupBtn">Click To Login</button>
  
</div>

<div> 




</div>
</form>
    

  
   </div>

  
     </div>
     <div></div>
     </div>

       
       
            
                
                <div className="content-bottom">

        </div>
    </div>
</div>:""
 }  
    </>

}
export default CRMLogin;

